const initLoginForm = () => {
	const loginForm = document.querySelector( '#cga_loginform' );
	if ( !loginForm ) {
		return;
	}
	const loginRemember = loginForm.querySelector( '.login-remember > label' );
	if ( loginRemember ) {
		loginRemember.innerHTML += '<span class="checkmark"></span>';
	}
};

const closeUserProfileMenuPanel = ( ev, userProfile ) => {
	const hasMenuPanel = ev.target.closest( '.menu-panel' );
	const hasTrigger = ev.target.closest( '.trigger' );
	if ( hasTrigger !== null ) {
		return;
	}
	if ( hasMenuPanel !== null ) {
		return;
	}

	// Close menu panel
	const menuPanel = userProfile.querySelector( '.menu-panel' );
	menuPanel.classList.remove( 'menu-appear' );
};

const initUserProfileMenu = ( profileMenu ) => {
	const trigger = profileMenu.querySelector( '.trigger' );
	if ( !trigger ) {
		return;
	}

	const menuPanel = profileMenu.querySelector( '.menu-panel' );
	trigger.addEventListener( 'click', ( ev ) => {
		ev.preventDefault();
		menuPanel.classList.toggle( 'menu-appear' );
	});

	document.addEventListener( 'click', ( ev ) => {
		closeUserProfileMenuPanel( ev, profileMenu );
	});
};

const initUserProfileMenus = () => {
	const profileMenus = document.querySelectorAll( '.user-profile-menus' );
	if ( profileMenus.length > 0 ) {
		profileMenus.forEach( ( profileMenu ) => {
			initUserProfileMenu( profileMenu );
		});
	}
};

const initUserProfiles = () => {
	const userProfiles = document.querySelectorAll( '.user-profile-info' );
	if ( userProfiles.length === 0 ) {
		return;
	}
	// userProfiles.forEach( ( userProfile ) => {
	// 	initUserProfile( userProfile );
	// });
};

const initPage = () => {
	initLoginForm();
	initUserProfileMenus();
};

const initMemberPage = () => {

	initPage();

}

export default initMemberPage;